"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signer = exports.OPERATION = void 0;
const ethers_1 = require("ethers");
var OPERATION;
(function (OPERATION) {
    OPERATION[OPERATION["CALL"] = 0] = "CALL";
    OPERATION[OPERATION["DELEGATE_CALL"] = 1] = "DELEGATE_CALL";
    OPERATION[OPERATION["CREATE"] = 2] = "CREATE";
})(OPERATION = exports.OPERATION || (exports.OPERATION = {}));
const signer = async function (signer, verifyingContract, to, value, data, operation, txGasEstimate, baseGasEstimate, gasPrice, txGasToken, refundReceiver, nonce) {
    if (!ethers_1.BigNumber.isBigNumber(value)) {
        value = ethers_1.BigNumber.from(value);
    }
    let typedData = {
        types: {
            EIP712Domain: [
                { type: "address", name: "verifyingContract" }
            ],
            // "SafeTx(address to,uint256 value,bytes data,uint8 operation,uint256 safeTxGas,uint256 baseGas,uint256 gasPrice,address gasToken,address refundReceiver,uint256 nonce)"
            SafeTx: [
                { type: "address", name: "to" },
                { type: "uint256", name: "value" },
                { type: "bytes", name: "data" },
                { type: "uint8", name: "operation" },
                { type: "uint256", name: "safeTxGas" },
                { type: "uint256", name: "baseGas" },
                { type: "uint256", name: "gasPrice" },
                { type: "address", name: "gasToken" },
                { type: "address", name: "refundReceiver" },
                { type: "uint256", name: "nonce" },
            ]
        },
        domain: {
            verifyingContract
        },
        primaryType: "SafeTx",
        message: {
            to: to,
            value: value.toHexString(),
            data: data,
            operation: operation,
            safeTxGas: txGasEstimate,
            baseGas: baseGasEstimate,
            gasPrice: gasPrice,
            gasToken: txGasToken,
            refundReceiver: refundReceiver,
            nonce: ethers_1.BigNumber.from(nonce).toNumber()
        }
    };
    const addr = await signer.getAddress();
    let sig = await signer.provider.send("eth_signTypedData", [addr, typedData]);
    return sig;
};
exports.signer = signer;
